/** お知らせの一覧(/notifications)。アプリの外・ログインの中に置く。 */
import { Card, Typography } from "antd";

import { useNotifications } from "./notificationHooks";
import { DeleteReadButton, NotificationList } from "./notifications";

export function NotificationsPage() {
  const query = useNotifications(50);

  return (
    <div style={{ padding: 24 }}>
      <Typography.Title level={3}>お知らせ</Typography.Title>
      <Typography.Paragraph type="secondary">
        自分宛と全体宛のお知らせ。新しい順。押すと関係する画面へ移り、そのとき既読になる。
        既読は行の「消す」か「既読を消す」で片付けられる(未読は残る)。全体宛は全員に 1 つなので、消せるのは suite:admin だけ。
      </Typography.Paragraph>
      <Card
        size="small"
        title={`未読 ${query.data?.unread ?? 0} 件 / 全 ${query.data?.total ?? 0} 件`}
        extra={<DeleteReadButton disabled={(query.data?.total ?? 0) <= (query.data?.unread ?? 0)} />}
      >
        <NotificationList rows={query.data?.items ?? []} loading={query.isFetching} />
      </Card>
    </div>
  );
}
